import { makeCygnusApiCall } from "../../../api/api";
import { MappingRecord, VendorFieldsResponse } from "./ClientDataMapping.types"

/**
 * Fetches the mapping data from the API
 * @param form_id - The form id
 * @returns A Promise resolving to the mapping data
 */
export const fetchMappingData = async (
  form_id?: string
): Promise<MappingRecord[]> => {  

  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/data_mapping/${form_id ?? ''}`,
    show_message: true,
    customized_success_message: "Fetched mapping data successfully.",
    customized_failure_message: "Failed to mapping data.",
    customized_error_message: "Error occurred while fetching mapping data.",
    isblob: false,
    forMDM: true,
  });

  return response?.data ?? [];
};

/**
 * Fetches the firm fields for all vendors from the API
 * @returns A Promise resolving to the vendor fields data
 */
export const fetchFirmFields = async (): Promise<VendorFieldsResponse> => {  

  const response = await makeCygnusApiCall({
    type: "GET",
    url: `/onboarding/vendor_fields/`,
    show_message: true,
    customized_success_message: "Fetched vendor fields data successfully.",
    customized_failure_message: "Failed to vendor fields data.",
    customized_error_message: "Error occurred while vendor fields data.",
    isblob: false,
    forMDM: true,
  });

  return response?.data ?? {};
};

/**
 * Saves the mapping source of truth for vendor fields
 * @param requestBody - object which includes client type and selected fields to update source of truth
 * @returns A Promise resolving to a success boolean
 */
export const updateMapping = async (requestBody: any): Promise<any> => {  

  const response = await makeCygnusApiCall({
    type: "POST",
    url: `/data_mapping/`,
    payload: requestBody,
    show_message: true,
    customized_success_message: "Mapping successfully updated!",
    customized_failure_message: "Failed to update mapping.",
    customized_error_message: "Error occurred while updating mapping",
    isblob: false,
    forMDM: true,
  });

  return response?.success ?? false;
};